interface AccountSettingsErrorResponse {
  errorCode?: number | null
  errorMessage?: string | null
}

interface ErrorKeysByContext {
  [context: string]: Record<number, string>
}

const errorKeysByContext: ErrorKeysByContext = {
  sendVerificationCode: {
    1: 'accountSettings.generalInfo.phoneNumber.errors.invalid',
    2: 'accountSettings.generalInfo.phoneNumber.errors.tooManyAttempts'
  },
  enableMfaSms: {
    1: 'accountSettings.generalInfo.mfa.errors.phoneNotVerified',
    2: 'accountSettings.generalInfo.mfa.errors.tooManyAttempts',
    3: 'accountSettings.generalInfo.mfa.errors.alreadyEnabled'
  },
  disableMfaSms: { 1: 'accountSettings.generalInfo.mfa.errors.alreadyDisabled' }
}

const errorKeysByMessage: Record<string, string> = {
  'Email address is missing or empty.':
    'accountSettings.generalInfo.email.noEmailError',
  'Invalid email address format.':
    'accountSettings.generalInfo.email.invalidEmailError',
  'Provided email matches existing email.':
    'accountSettings.generalInfo.email.sameEmailError',
  'Email address already in use.':
    'accountSettings.generalInfo.email.unavailableError',
  'Email address not available.':
    'accountSettings.generalInfo.email.unavailableError',
  'Input phone number not valid.':
    'accountSettings.generalInfo.phoneNumber.errors.invalid',
  'Too many attempts. Try again later or contact support for further assistance.':
    'accountSettings.generalInfo.phoneNumber.errors.tooManyAttempts',
  'Phone number must be verified before enabling multi-factor authentication.':
    'accountSettings.generalInfo.mfa.errors.phoneNotVerified',
  'Multi-factor authentication is already enabled with the phone number associated with your account.':
    'accountSettings.generalInfo.mfa.errors.alreadyEnabled'
}

export function getAccountSettingsErrorKey(
  context: string,
  response: AccountSettingsErrorResponse
): string | undefined {
  const codeKey =
    response.errorCode == null
      ? undefined
      : errorKeysByContext[context]?.[response.errorCode]

  return (
    codeKey ??
    (response.errorMessage
      ? errorKeysByMessage[response.errorMessage]
      : undefined)
  )
}
